import { importLibrary, setOptions } from "@googlemaps/js-api-loader"
import { Controller } from "@hotwired/stimulus"
import { useIntersection } from "stimulus-use"

export default class extends Controller {
  static values = { apiKey: String, latitude: Number, longitude: Number, mapId: String }

  connect() {
    this.loaded = false
    useIntersection(this)
  }

  appear() {
    if (this.loaded) return

    this.loaded = true

    setOptions({
      key: this.apiKeyValue
    })

    Promise.all([importLibrary("maps"), importLibrary("marker")]).then(([maps, marker]) => {
      const position = {
        lat: this.latitudeValue,
        lng: this.longitudeValue
      }

      const googleMapsLink = `https://www.google.com/maps/search/?api=1&query=${this.latitudeValue},${this.longitudeValue}`

      const contentString = `<div class="text-center mt-3 mb-1 ms-1">
          <a href="${googleMapsLink}" target="_blank" class="fw-bold fs-6">Get Directions</a>
        </div>`

      const infowindow = new maps.InfoWindow({
        content: contentString
      })

      const map = new maps.Map(this.element, {
        center: position,
        zoom: 14,
        mapId: this.mapIdValue,
        mapTypeControl: false,
        controlSize: 30
      })

      const anchor = new marker.AdvancedMarkerElement({
        position,
        map
      })

      infowindow.open({
        anchor
      })
    })
  }
}
